import React from 'react';
import { TextFieldProps } from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

import { FormInput, IProps as IFormInput } from './FormInput';

export type Option = {
  v: any;
  c: string;
};

interface IProps extends IFormInput {
  options: Option[];
  multiple?: boolean;
}

export const FormSelect: React.FC<TextFieldProps & IProps> = ({ options, multiple, ...props }) => {
  const optionElements = options.map((option) => (
    <MenuItem value={option.v} key={option.v}>
      {option.c}
    </MenuItem>
  ));

  return (
    <FormInput SelectProps={{ multiple }} {...props} select={true}>
      {optionElements}
    </FormInput>
  );
};
